/* tslint:disable */
/* eslint-disable */
/**
 * Scania Configurator
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { MainMenuNode } from './MainMenuNode'
import {
  MainMenuNodeFromJSON,
  MainMenuNodeFromJSONTyped,
  MainMenuNodeToJSON,
} from './MainMenuNode'

/**
 *
 * @export
 * @interface LoadConfigOkResult
 */
export interface LoadConfigOkResult {
  /**
   *
   * @type {Array<MainMenuNode>}
   * @memberof LoadConfigOkResult
   */
  mainMenus: Array<MainMenuNode>
}

/**
 * Check if a given object implements the LoadConfigOkResult interface.
 */
export function instanceOfLoadConfigOkResult(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'mainMenus' in value

  return isInstance
}

export function LoadConfigOkResultFromJSON(json: any): LoadConfigOkResult {
  return LoadConfigOkResultFromJSONTyped(json, false)
}

export function LoadConfigOkResultFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): LoadConfigOkResult {
  if (json === undefined || json === null) {
    return json
  }
  return {
    mainMenus: (json['mainMenus'] as Array<any>).map(MainMenuNodeFromJSON),
  }
}

export function LoadConfigOkResultToJSON(
  value?: LoadConfigOkResult | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    mainMenus: (value.mainMenus as Array<any>).map(MainMenuNodeToJSON),
  }
}
